function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 7a2 2 0 000 4 5 5 0 015 5 2 2 0 004 0 9 9 0 00-9-9zm0 7a2 2 0 102 2 2 2 0 00-2-2zM2 0a2 2 0 000 4c6.627 0 12 5.373 12 12a2 2 0 004 0C18 7.163 10.837 0 2 0z",
  fill: "#222"
});

function SvgRss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIgN2EyIDIgMCAwMDAgNCA1IDUgMCAwMTUgNSAyIDIgMCAwMDQgMCA5IDkgMCAwMC05LTl6bTAgN2EyIDIgMCAxMDIgMiAyIDIgMCAwMC0yLTJ6TTIgMGEyIDIgMCAwMDAgNGM2LjYyNyAwIDEyIDUuMzczIDEyIDEyYTIgMiAwIDAwNCAwQzE4IDcuMTYzIDEwLjgzNyAwIDIgMHoiIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0iIzIyMiIvPjwvc3ZnPgo=";
export { SvgRss as ReactComponent };